export const FEATURES = {
  CONTENT: 'content',
} as const
